import duwaStore from './store'

export default class DuwaModule {
  name = 'duwa'
  constructor({ store }) {
    store.registerModule(this.name, duwaStore)
  }
}
